import React, { Component, Fragment, type ReactElement } from 'react'
import BackToTop from '../../common/BackToTop/BackToTop'
import Footer from '../../common/Footer/Footer'
import images from '../../common/images'
import NavigationButton from '../../common/NavigationButton/NavigationButton'
import home from '../../images/home.mp4'
// import Services from './Services/Services'
import HeaderWrapper from '../../common/Header/HeaderWrapper/HeaderWrapper'
import HamburgerMenuHandler from '../../common/Header/HeaderHandler/HamburgerMenuHandler'
import SideBarMenuMobile from '../../common/SideBarMenuMobile/SideBarMenuMobile'
import LoadingState from '../../common/LoadingState/LoadingState'
import type INewsPresenter from '../News/Presenter/INewsPresenter'
import NewsCard from '../News/NewsCard/NewsCard'
import type ISubscriber from '../../common/ISubscriber'
import './style.scss'
import type NewsDto from '../News/Presenter/NewsDto'

interface Props {
  newsPresenter: INewsPresenter
}

function ServiceSiteLink ({ href, service }: { href: string, service: string }): ReactElement {
  return (
    <div className='service-siteLinkWrapper'>
      <a
        className='service-siteLink'
        href={href}
        target='_blank'
        rel='noreferrer'
        referrerPolicy='no-referrer'
        aria-label={`${service} サービスサイトへ（新しいタブで開く）`}
      >
        <span className='service-siteLinkIcon' aria-hidden='true'>
          <img src={images.openLink} alt='' width='16' height='16' />
        </span>
        <span className='service-siteLinkText'>サービスサイトへ</span>
      </a>
    </div>
  )
}

const MAX_VISIBLE_NEWS_IN_HOME_PAGE = 4
class Home extends Component<Props> implements ISubscriber {
  componentDidMount(): void {
    document.title = 'IVA｜価値の覚醒で、世界に熱狂を。｜ホーム'
    document.addEventListener('wheel', this.handleScroll)
    document.addEventListener('scroll', this.handleScroll)
    this.props.newsPresenter.setView(this)
  }

  componentWillUnmount(): void {
    document.removeEventListener('wheel', this.handleScroll)
    document.removeEventListener('scroll', this.handleScroll)
    this.props.newsPresenter.clearView()
  }

  render(): ReactElement {
    const { newsPresenter } = this.props

    if (newsPresenter.isLoading()) {
      return <LoadingState />
    }

    const news = newsPresenter.getTopNews()
    return (
      <Fragment>
        <div style={{ backgroundColor: '#2f2f2f' }}>
          <LoadingState />
          <div className='home main-content'>
            <Fragment>
              <HeaderWrapper shouldShowBlackLogo={false} />
              <BackToTop />
            </Fragment>
            <div className='home-video'>
              <video autoPlay={true} controls={false} muted loop={true} playsInline width='100%'>
                <source src={home} type='video/mp4' />
                Sorry, your browser does not support videos.
              </video>
              <div className='home-title'>
                <h1>価値の覚醒で、世界に熱狂を。</h1>
                <p>Unlock Value. Power the World.</p>
              </div>
              <div className='home-scroll' onClick={this.scrollToNews}>
                <span className='home-scrollText'>Scroll</span>
              </div>
            </div>
            <div className='home-news container'>
              <h2 className='h2-en' id='news'>
                NEWS
              </h2>
              <div
                className='home-newsPreview text-link section-animation'
                style={this.setNewsPreviewStyling(news)}
              >
                {news.map((newsDto) => {
                  return (
                    <NewsCard
                      category={newsDto.category}
                      id={newsDto.id}
                      image={newsDto.cover}
                      date={newsDto.date}
                      key={newsDto.id}
                      tag={newsDto.category.name}
                      link={newsDto.link}
                      preview={newsDto.title}
                      type={newsDto.type}
                    />
                  )
                })}
              </div>
              <div className='home-navButtonWrapper'>
                <NavigationButton height='50' label='ニュース一覧を見る' path='news' width='285' />
              </div>
            </div>
            <div className='home-company container'>
              <h2 className='h2-en'>COMPANY</h2>
              <div className='home-companyContent'>
                <div className='home-companyImage section-animation'>
                  <img alt='company' src={images.companyBuilding} />
                </div>
                <div className='home-companyIntro section-animation'>
                  <div className='home-companyTitles'>
                    <h1>
                      モノの可能性を最大化し、
                      <br />
                      価値経済の統合基盤を築く。
                    </h1>
                    <p className='home-companySubtitle'>
                      Maximize the Potential of Assets.
                      <br />
                      Build the Foundation of the Value Economy.
                    </p>
                  </div>
                  <div className='home-companyIntroContent'>
                    <p>
                      あらゆるモノの可能性を最大限に引き出すために、価値の評価から流通までを一体化した、次世代の経済基盤を構築します。
                    </p>
                    <p>
                      個人と企業、国や地域の垣根を越え、分断された需要と供給をつなぎ、世界の価値流通における、あらゆる限界を突破していきます。
                    </p>
                  </div>
                </div>
              </div>
              <div className='home-navButtonWrapper'>
                <NavigationButton height='50' label='会社概要を見る' path='company' width='285' />
              </div>
            </div>
            <div className='home-service'>
              <div className='container'>
                <h2 className='h2-en-white'>SERVICES</h2>
                <div className='home-serviceContent service-content'>
                  <div className='home-buildWithUsImage section-animation'>
                    <div className='service-banner'>
                      <img className='service-image' alt='service' src={images.serviceImage1} />
                    </div>
                    <div>
                      <h2 className='service-item-title h2-en-white text-center'>FAKEBUSTERS</h2>
                      <p className='white'>
                        FAKEBUSTERS（フェイクバスターズ）はラグジュアリーアイテムやスニーカー、トレカ、ストリートウェア、時計、ジュエリーなどのAI真贋鑑定サービスです。
                      </p>
                      <p className='white'>
                        多彩な経歴を持つ鑑定チームと最新鋭の専門機器、AI鑑定技術を駆使して、コンシューマー向けサービスに加え、マーケットプレイスやリユース企業をはじめとする多様な事業者の信頼性向上を支援しています。現在までに累計200万件以上のお客様にご利用いただいています。
                      </p>
                      <ServiceSiteLink href='https://www.fakebusters-iva.com' service='FAKEBUSTERS' />
                    </div>
                  </div>
                  <div className='home-buildWithUsImage section-animation'>
                    <div className='service-banner'>
                      <img className='service-image' alt='service' src={images.serviceImage2} />
                    </div>
                    <div>
                      <h2 className='service-item-title h2-en-white text-center'>
                      CHALYN
                      </h2>
                      <p className='white'>
                        Chalyn（チャリン）は写真を撮るだけで手元のアイテムを現金化できるAI即金アプリです。ユーザーが撮った写真を自動査定し、瞬時に金額を提示。商品を発送すると最終査定が行われ、現金化が可能になります。
                        <br />
                        これまでフリマアプリで課題とされてきた「出品」「梱包」「取引相手とのやり取り」といった手間をすべて解消し、誰でも気軽に不用品を現金化できる新しい売却体験を提供します。
                      </p>
                      <ServiceSiteLink href='https://chalyn.com' service='Chalyn' />
                    </div>
                  </div>
                  <div className='home-buildWithUsImage section-animation'>
                    <div className='service-banner'>
                      <img className='service-image' alt='service' src={images.serviceImage3} />
                    </div>
                    <div>
                      <h2 className='service-item-title h2-en-white text-center'>
                        CIRCULAR ECONOMY SOLUTIONS
                      </h2>
                      <p className='white'>
                        IVAではサーキュラーエコノミー（循環型経済）の実現・推進に向けてさまざまなソリューションを展開しています。
                        <br />
                        希少商材の大口調達を専門のバイヤーチームが代行する「ホールセール」事業や、幅広いカテゴリーの商品流通を支援する「商品買取」サービスなど、多くのマーケットプレイス・リユース企業様の事業成長を支援しています。
                      </p>
                    </div>
                  </div>
                  <div className='home-buildWithUsImage section-animation'>
                    <div className='service-banner'>
                      <img className='service-image' alt='service' src={images.serviceImage4} />
                    </div>
                    <div>
                      <h2 className='service-item-title h2-en-white text-center'>
                        3RD PARTY LOGISTICS
                      </h2>
                      <p className='white'>
                        IVAの3PL（サードパーティ・ロジスティクス）は、商品の保管・検品・真贋鑑定・梱包・発送までをワンストップで提供する物流ソリューションです。
                        <br />
                        物流機能と真贋鑑定機能を一体化することで、商品の信頼性を担保しながらスムーズな流通を実現。FAKEBUSTERSが培った知見と独自のオペレーション体制を活かし、マーケットプレイス、リユース企業、購入代行・越境EC事業者様の成長を支える物流インフラを提供しています。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='home-services'>{/* <Services /> */}</div>
            <div className='home-careers container'>
              <h2 className='h2-en'>JOIN US</h2>
              <div className='home-careersContent align-items-center'>
                <div className='home-careersImage section-animation'>
                  <img alt='careers' src={images.buildWithUs} />
                </div>
                <div className='home-careersIntro section-animation'>
                  <h1>あなたの才能が、未来を創る</h1>
                  <div className='home-careersIntroContent'>
                    <p>
                      IVAが挑むのは、世界中のあらゆる「価値」が関わる巨大なマーケットです。
                      <br />
                      非効率でアナログな商習慣が根付いてきた歴史ある産業が今、AIとテクノロジーによって大きな転換期を迎えています。私たちは、その変革の最前線にいます。
                      <br />
                      「200年の常識を超え、次の時代を創る。」
                    </p>
                    <p>私たちは、そんな時代を一緒につくる仲間を募集しています。</p>
                  </div>
                </div>
              </div>
              <div className='home-navButtonWrapper'>
                <NavigationButton height='78px' label='採用情報を見る' path='careers' width='286px' />
              </div>
            </div>
            <Footer />
          </div>
        </div>
        <SideBarMenuMobile handler={new HamburgerMenuHandler(false)} />
      </Fragment>
    )
  }

  private readonly handleScroll = (): void => {
    this.handleAnimationElements()
  }

  private readonly handleAnimationElements = (): void => {
    const animationElements = document.querySelectorAll('.section-animation')
    const windowHeight = window.innerHeight

    for (let i = 0; i < animationElements.length; i++) {
      const elementTop = animationElements[i].getBoundingClientRect().top
      const elementVisible = 10

      if (elementTop < windowHeight - elementVisible) {
        animationElements[i].classList.add('active')
      } else {
        animationElements[i].classList.remove('active')
      }
    }
  }

  update = (): void => {
    this.setState({})
  }

  private readonly scrollToNews = (): void => {
    const news = document.getElementById('news') as HTMLElement
    news.scrollIntoView({ behavior: 'smooth' })
    const header = document.getElementById('header') as HTMLElement
    if (header) {
      header.style.display = 'none'
    }
  }

  private readonly setNewsPreviewStyling = (news: NewsDto[]): object => {
    return {
      gridTemplateColumns: `${
        news.length < MAX_VISIBLE_NEWS_IN_HOME_PAGE
          ? `repeat(${news.length}, 1fr)`
          : 'repeat(4, 1fr)'
      }`
    }
  }
}

export default Home
